import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLDivElement
  Blocks: {
    default: []
  }
}

export const BookLibraryFilterRow: TOC<Signature> = <template>
  <div class="border-dusty-black-50 border-b-2" ...attributes>
    {{yield}}
  </div>
</template>

export default BookLibraryFilterRow
